export default __webpack_public_path__ + "static/media/ce-rosetta-inbound.2b486376.png";